export default "__VITE_ASSET__MZ_v4Y90__"